import { ComponentProps, useEffect, useState } from 'react'

import { Input } from '~/components/inputs/Input'

export const DebouncedInput = ({
  ref,
  value: initialValue,
  onChange,
  debounce = 10,
  ...props
}: {
  value: string
  onChange: (value: string) => void
  debounce?: number
} & Omit<ComponentProps<typeof Input>, 'onChange'> & {
    ref?: React.RefObject<HTMLInputElement | null>
  }) => {
  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value)
    }, debounce)

    return () => clearTimeout(timeout)
  }, [debounce, onChange, value])

  return (
    <Input
      {...props}
      ref={ref}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  )
}

DebouncedInput.displayName = 'DebouncedInput'
